import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Bearer-token auth (localStorage) — works identically same-origin and cross-origin (custom
// domains). No withCredentials, so requests are never credentialed and a wildcard CORS origin
// from the ingress is always accepted by the browser.
const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("phs_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// Error extractor for requests made with responseType:"blob" — the error body arrives as a Blob,
// so the friendly `detail` message must be read out of it (e.g. a 404 "no POD yet").
export async function blobApiError(err) {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      if (parsed?.detail) return apiError({ response: { data: parsed } });
    } catch { /* not JSON */ }
  }
  return apiError(err);
}

export default api;
